import { colors, Tag } from '@sweep-io/sweep-design';
import { ConfigurationToName, ConfigurationType } from '../dependencies/types';
import { formatCamelCase } from '../universal-search/utils';

export const TypeTag = ({ configurationType }: { configurationType: ConfigurationType }) => {
  return (
    <Tag
      size="tiny"
      color={colors.grey[120]}
      label={ConfigurationToName[configurationType] ?? formatCamelCase(configurationType)}
    />
  );
};
